module.exports = __webpack_public_path__ + "img/fil.5b66dcda.svg";